import OrganizationInternalInformationView from './organization-internal-information-view'
export default OrganizationInternalInformationView
